import { Injectable } from '@angular/core';
import { PanelsService } from '@ispm/layout/services/panels.service';
import { Observable } from 'rxjs';
import { PanelLoaderPayload } from '@ispm/layout/classes/panel-loader-payload.abstract';
import { IGenericPanelConfiguration } from '@ispm/layout/interfaces/generic-panel.interface';



@Injectable()
export class PanelServiceWrapper {

  constructor(private panelService: PanelsService) { }

  public openPanel(component, config: IGenericPanelConfiguration, data): Observable<any> {
    const definition = PanelLoaderPayload.builder()
      .setTitle(config.innerTitle)
      .setPayload({ data, config});
    return this.panelService.showLayout(component, definition, config.name);
  }
}
